if (!customElements.get('lusso-purchase-guidance')) {
  customElements.define('lusso-purchase-guidance', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-purchase-variants]').textContent);
      this.host = this.closest('dialog, product-info') || this.parentElement;
      this.onChange = (event) => {
        if (event.target.matches('input[name="id"]')) this.update(event.target.value);
        if (event.target.matches('.ls-card-sizes input[name="variant-choice"]')) {
          // Quick view uses its own radio picker rather than the PDP's
          // variant-selects element. Update the dispatch message immediately
          // from the selected radio so iOS does not leave the generic prompt
          // visible after the size has visibly changed.
          this.update(event.target.value);
          return;
        }
        if (event.target.matches('variant-selects input, variant-selects select')) {
          const variant = this.variantForSelection();
          // Resolve the local variant immediately. The product-info component
          // still refreshes authoritative HTML in the background, but slow
          // networks no longer leave the shopper staring at a loading state.
          if (variant) {
            this.update(variant.id);
            const button = this.host.querySelector('[name="add"]');
            if (button) button.disabled = !variant.available;
          } else {
            this.pending();
          }
        }
      };
      this.host.addEventListener('change', this.onChange);
      this.update(this.dataset.selectedId);
    }
    disconnectedCallback() {
      this.host?.removeEventListener('change', this.onChange);
    }
    pending() {
      this.querySelector('[data-purchase-status]').textContent = this.dataset.pending;
      this.querySelector('[data-purchase-help]').hidden = true;
      this.updateLinks(null);
    }
    unavailable() {
      this.querySelector('[data-purchase-status]').textContent = this.dataset.unavailable;
      this.querySelector('[data-purchase-help]').hidden = true;
      this.updateLinks(null);
    }
    failed() {
      this.querySelector('[data-purchase-status]').textContent = this.dataset.error;
      this.querySelector('[data-purchase-help]').hidden = true;
      this.updateLinks(null);
    }
    refresh(html) {
      const source = html.querySelector('product-info lusso-purchase-guidance [data-purchase-variants]');
      if (source) this.variants = JSON.parse(source.textContent);
    }
    variantForSelection() {
      const picker = this.host.querySelector('variant-selects');
      if (!picker) return null;
      const values = [...picker.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value);
      picker.querySelectorAll('select').forEach((select) => values.push(select.value));
      if (!values.length) return null;
      return this.variants.find((variant) =>
        Array.isArray(variant.options) && variant.options.length === values.length &&
        variant.options.every((option, index) => option === values[index])
      ) || null;
    }
    update(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.querySelector('[data-purchase-status]').textContent = variant?.message || this.dataset.choose;
      this.querySelector('[data-purchase-help]').hidden = !variant;
      this.updateLinks(variant);
    }
    updateLinks(variant) {
      const url = new URL(this.dataset.url);
      if (variant) url.searchParams.set('variant', variant.id);
      const message = `${this.dataset.whatsappMessage} ${this.dataset.title}${variant ? ` - ${variant.title}` : ''}\n${url.href}`;
      this.host.querySelectorAll('[data-purchase-whatsapp], [data-assistance-whatsapp]').forEach(link => {
        link.href = `https://api.whatsapp.com/send?phone=917304766474&text=${encodeURIComponent(message)}`;
      });
    }
  });
}
